import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Phone, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

const StickyCTABar = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    // Check if previously dismissed in this session
    try {
      if (sessionStorage.getItem("sticky_cta_dismissed") === "true") {
        setIsDismissed(true);
        return;
      }
    } catch (e) {
      // Handle private browsing
    }

    const handleScroll = () => {
      // Show after scrolling 500px
      const shouldShow = window.scrollY > 500;
      setIsVisible(shouldShow);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleDismiss = () => {
    setIsDismissed(true);
    try {
      sessionStorage.setItem("sticky_cta_dismissed", "true");
    } catch (e) {
      // Handle private browsing
    }
  };

  if (isDismissed) return null;

  return (
    <div
      className={cn(
        "fixed bottom-0 left-0 right-0 z-50 transition-all duration-500 ease-out hidden md:block",
        isVisible ? "translate-y-0 opacity-100" : "translate-y-full opacity-0"
      )}
    >
      {/* Gradient accent line */}
      <div className="h-1 bg-gradient-to-r from-accent via-primary-foreground/20 to-accent" />
      
      <div className="glass bg-primary/95 border-t border-accent/20 shadow-lg shadow-primary/20">
        <div className="container mx-auto px-4 py-3">
          <div className="flex items-center justify-between gap-4">
            {/* Phone number - hidden on very small screens */}
            <a
              href="tel:+19898432600"
              className="hidden sm:flex items-center gap-2 text-primary-foreground hover:text-accent transition-colors group"
            >
              <Phone className="h-4 w-4 group-hover:scale-110 transition-transform" />
              <span className="text-sm font-medium">(989) 843-2600</span>
            </a>

            {/* CTA text */}
            <p className="text-primary-foreground/90 text-sm hidden md:block">
              Ready to grow your business online?
            </p>

            {/* Actions */}
            <div className="flex items-center gap-3 flex-1 sm:flex-none justify-end">
              <Button
                variant="secondary"
                size="sm"
                asChild
                className="whitespace-nowrap shadow-lg shadow-secondary/20 group"
              >
                <Link to="/contact">
                  Book Free Consultation
                </Link>
              </Button>
              
              <button
                onClick={handleDismiss}
                className="p-1.5 rounded-full hover:bg-primary-foreground/10 transition-colors text-primary-foreground/70 hover:text-primary-foreground"
                aria-label="Dismiss"
              >
                <X className="h-4 w-4" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StickyCTABar;
